export { default as SimpleLineIcon } from './component';
